import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getAppUser } from '../../app/appSelectors';
import { USER_STATE_NAMES } from './UserState.t';
import { LOCATION_COMPONENTS_SEARCH_PARAMS, LOCATION_NAMES } from '../Location/locationConstants';
import { useCallback, useEffect, useMemo } from 'react';
import { MOBILE_SLIDER_PAGES_IDS } from '../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants';
import { MODALS_NAME } from '../Modals/modalsConstants';
import { locationSlice } from '../Location/locationReducer';
import appHistory, { excludeSearchParams } from '../../app/appHistory';

function UserStateInformationProvider() {
    const location = useLocation();
    const dispatch = useDispatch();
    const user = useSelector(getAppUser);

    const [openedSlides, openedModals, openedTabs] = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        return [searchParams.getAll(LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE), searchParams.getAll(LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL), searchParams.getAll(LOCATION_COMPONENTS_SEARCH_PARAMS.TAB)];
    }, [location.search]);

    const openUserStatusModal = useCallback(() => {
        dispatch(locationSlice.actions.addLocationAction({
            name: LOCATION_NAMES.USER_STATE_INFORMATION,
        }));
    }, [dispatch]);


    useEffect(() => {
        const isUserActive = user.state && user.state === USER_STATE_NAMES.ACTIVE;
        const isUserBlocked = user.state && user.state === USER_STATE_NAMES.BLOCKED;
        const isSliderWithdraw = openedSlides.includes(MOBILE_SLIDER_PAGES_IDS.WITHDRAW);
        const isSliderDeposit = openedSlides.includes(MOBILE_SLIDER_PAGES_IDS.DEPOSIT);
        const isModalCashierWithdraw = openedModals.includes(MODALS_NAME.CASHIER) && openedTabs.includes('withdraw');
        const isModalCashierDeposit = openedModals.includes(MODALS_NAME.CASHIER) && openedTabs.includes('deposit');
        const isWithdrawOpened = isSliderWithdraw || isModalCashierWithdraw;
        const isDepositOpened = isSliderDeposit || isModalCashierDeposit;
        const isUserStateInformationOpened = openedModals.includes(MODALS_NAME.USER_STATE_INFORMATION);

        if (isUserStateInformationOpened) return;

        if (isUserBlocked && isWithdrawOpened) {
            const searchParams = excludeSearchParams({
                [LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE]: MOBILE_SLIDER_PAGES_IDS.WITHDRAW,
                [LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL]: MODALS_NAME.CASHIER,
                [LOCATION_COMPONENTS_SEARCH_PARAMS.TAB]: 'withdraw',
            });
            appHistory.replace({
                search: searchParams.toString(),
            });
            openUserStatusModal();
            return;
        }
        if (!isUserActive && isDepositOpened) {
            const searchParams = excludeSearchParams({
                [LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE]: MOBILE_SLIDER_PAGES_IDS.DEPOSIT,
                [LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL]: MODALS_NAME.CASHIER,
                [LOCATION_COMPONENTS_SEARCH_PARAMS.TAB]: 'deposit',
            });
            appHistory.replace({
                search: searchParams.toString(),
            });
            openUserStatusModal();
            return;
        }
    }, [user.state, openedSlides, openedTabs, openedModals, dispatch, openUserStatusModal]);

    return null;
}

export default UserStateInformationProvider;
